import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-purple/theme.css';
import { ReportHeader } from '../../header/report-header';
import { CoursesExceedingHoursFilter } from './side-bar-filter/courses-exceeding-hours-filter';
import Colors from '../../../../utils/colors';
import { fetchCourseExceedingHourOperations } from './operations/fetch-course-exceeding-hour-operations';
import { CoursesExceedingHoursFilterDatamodel } from './side-bar-filter/courses-exceeding-hours-filter-datamodel';
import { CourseHoursExceedingReport } from '../../../../api/types/reports/finanace/course-hours-excess-report';
import { numberToHebrewLetter } from '../../../../utils/hebrew-date-utils';

export const ReportCoursesExceedingHour = () => {
  const [data, setData] = useState<CourseHoursExceedingReport[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentFilters, setCurrentFilters] =
    useState<CoursesExceedingHoursFilterDatamodel>();

  const getExceedingHoursStyle = (hours: number) => {
    if (hours >= 10) return { color: Colors.dangerText2, fontWeight: 'bold' };
    if (hours >= 5)
      return { color: Colors.warningYelloText, fontWeight: 'bold' };
    return { color: Colors.approveText2, fontWeight: 'bold' };
  };

  const handleSearch = async (
    filters: CoursesExceedingHoursFilterDatamodel,
  ) => {
    setCurrentFilters(filters);
    await fetchCourseExceedingHourOperations(filters, setLoading, setData);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ReportHeader
        title="דו״ח חריגת שעות בקורסים"
        description="דו״ח זה מציג מידע על קורסים שחרגו מכמות השעות המתוכננת. הדו״ח כולל פירוט של מכסת השעות, שעות בפועל והיקף החריגה."
        metadata={[
          { label: 'מטרת הדו״ח', value: 'בקרה תקציבית ותכנון שעות' },
          { label: 'תדירות עדכון', value: 'שבועי' },
        ]}
        category="financial"
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        <div
          style={{
            height: 'calc(100vh - 230px)',
            minHeight: '100%',
            width: '300px',
            minWidth: '250px',
          }}
        >
          <CoursesExceedingHoursFilter onSearch={handleSearch} />
        </div>

        {/* Table Section */}
        <div style={{ flex: 1 }}>
          <DataTable
            value={data}
            loading={loading}
            rowHover
            rowClassName={() => 'cursor-pointer'}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage={
              <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
            }
            dataKey="id"
            scrollable
            scrollHeight="calc(100vh - 230px)"
            tableStyle={{
              direction: 'rtl',
            }}
          >
            <Column
              field="branchName"
              header="שלוחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="abstractProgramName"
              header="תוכנית לימודים"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            {/*<Column
              field="programStartYear"
              header="שנת התחלה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />*/}
            <Column
              field="annualSerialProgramNumber"
              header="מספר תוכנית בשנה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="programYear"
              header="שנה בתוכנית"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData) => (
                <label>{numberToHebrewLetter(rowData.programYear)}'</label>
              )}
            />
            <Column
              field="courseName"
              header="שם קורס"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="courseHours"
              header="מכסת שעות מקורית"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="capacityHours"
              header="מכסת שעות עדכנית"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="scheduledHours"
              header="מספר שעות ששובצו"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              header=" חריגת שעות שבוצעו ביחס לתכנון "
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData: CourseHoursExceedingReport) => {
                if (
                  rowData.hoursActuallyWorked === null ||
                  rowData.scheduledHours === null
                ) {
                  return <span>NaN</span>;
                }

                const exceedingHours = (
                  rowData.hoursActuallyWorked - rowData.scheduledHours
                ).toFixed(2);

                return (
                  <span
                    style={{
                      color:
                        exceedingHours > 0 ? Colors.dangerText2 : 'inherit',
                      fontWeight: exceedingHours > 0 ? 'bold' : 'normal',
                    }}
                  >
                    {exceedingHours > 0 ? exceedingHours : 0}
                  </span>
                );
              }}
            />
            <Column
              field="hoursActuallyWorked"
              header="סך שעות בפועל"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />

            {/*            <Column
              field="averageTeachingHourCost"
              header="עלות ממוצעת של שעת הוראה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData) =>
                `₪${Math.round(rowData.averageTeachingHourCost)}`
              }
            />*/}
          </DataTable>
        </div>
      </div>
    </div>
  );
};
